import script from "./ABSAddViolationAction.vue?vue&type=script&setup=true&lang=js"
export * from "./ABSAddViolationAction.vue?vue&type=script&setup=true&lang=js"

import "./ABSAddViolationAction.vue?vue&type=style&index=0&id=5a491c76&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a491c76"]])

export default __exports__